/** Message unique affiché quand la base refuse un texte (liste admin de mots interdits). */
export const BANNED_WORD_MESSAGE = "Ce texte contient un mot interdit.";

/** Vrai si l'erreur (base ou fonction serveur) vient de la liste de mots interdits. */
export const isBannedWordError = (error: unknown): boolean => {
  const message =
    typeof error === "string"
      ? error
      : typeof (error as { message?: unknown })?.message === "string"
      ? (error as { message: string }).message
      : "";
  return message.toLowerCase().includes("mot interdit");
};

/** Renvoie le message « mot interdit » si besoin, sinon le message de repli. */
export const bannedWordOr = (error: unknown, fallback: string): string =>
  isBannedWordError(error) ? BANNED_WORD_MESSAGE : fallback;

/** Lit le corps d'une erreur de fonction serveur (réponse 400) pour y chercher le refus « mot interdit ». */
export const isBannedWordFunctionError = async (error: unknown): Promise<boolean> => {
  if (isBannedWordError(error)) return true;
  try {
    const context = (error as { context?: Response })?.context;
    if (!context || typeof context.clone !== "function") return false;
    const body = await context.clone().json();
    return isBannedWordError(body?.error);
  } catch {
    return false;
  }
};
